import { en } from './en';
import { tr } from './tr';
import { settings } from '@/config/settings';

export type I18nKey = keyof typeof en;

const dicts: Record<string, Record<I18nKey, string>> = { en, tr };

/**
 * Translate a key using the active language (settings.language).
 * `{param}` placeholders are replaced from `params`.
 * UI screens must (re)build their texts on show/refresh so a language
 * change is reflected the next time they open.
 */
export function t(key: I18nKey, params?: Record<string, string | number>): string {
  const dict = dicts[settings.language] ?? en;
  let s: string = dict[key] ?? en[key] ?? key;
  if (params) {
    for (const [k, v] of Object.entries(params)) {
      s = s.replace(`{${k}}`, String(v));
    }
  }
  return s;
}
